import gql from 'graphql-tag'
import moment from 'moment'

export const TEACHER_QUERY = gql`
        query apolloJournals($offset: Int, $limit: Int, $start_time: timestamptz, $end_time: timestamptz, $groupIds: [Int!], $studentId: Int, $status: [enum_general_status_enum!]) {
          journals: user_content(where: {type: {_eq: JOURNAL}, status: {_in: $status}, updated_at: {_gte: $start_time, _lte: $end_time}, user: {user_groups: {group_id: {_in: $groupIds}}, id: {_eq: $studentId}}}, order_by: {created_at: desc}, limit: $limit, offset: $offset) {
            id
            status
            created_at
            updated_at
            group_id
            content {
              id
              title
              body
              files: content_assets {
                asset {
                  id
                  type
                  description
                  url
                }
              }
            }
            user {
              id
              firstname
              lastname
              avatar_url
              user_groups(where: {group: {type: {_eq: SECTION}}}) {
                group_id
              }
            }
          }
          user_content_aggregate(where: {type: {_eq: JOURNAL}, status: {_in: [ACKNOWLEDGED, SUBMITTED]}, updated_at: {_gte: $start_time, _lte: $end_time}, user: {user_groups: {group_id: {_in: $groupIds}}}}, order_by: {created_at: desc}) {
            aggregate {
              count
            }
          }
        }
        `

export const STUDENT_QUERY = gql`
          query apolloJournals($user_id: Int, $offset: Int, $limit: Int) {
            journals: user_content(where: {type: {_eq: JOURNAL}, user_id: {_eq: $user_id}, _not: {_or: [{status: {_eq: ARCHIVED}}, {status: {_eq: DELETED}}]}}, order_by: {created_at: desc}, limit: $limit, offset: $offset) {
              id
              status
              created_at
              updated_at
              group_id
              content {
                id
                title
                body
                files: content_assets {
                  asset {
                    id
                    type
                    description
                    url
                  }
                }
              }
            }
            user_content_aggregate(where: {type: {_eq: JOURNAL}, user_id: {_eq: $user_id}, _not: {_or: [{status: {_eq: ARCHIVED}}, {status: {_eq: DELETED}}]}}, order_by: {created_at: asc}) {
              aggregate {
                count
              }
            }
          }
        `

export const DEV_QUERY = gql`
query apolloDevJournals($id: Int) {
  journals: user_content(where: {id: {_eq: $id}}) {
    id
    status
    created_at
    updated_at
    group_id
    content {
      id
      title
      body
      files: content_assets {
        asset {
          id
          type
          description
          url
        }
      }
    }
  }
}
`

export const SECTION_QUERY = gql`
       query apolloSection($id: Int) {
        group(where: {type: {_eq: SECTION}, user_groups: {user_id: {_eq: $id}} }) {
            id
            name
            user_groups {
              role_id
              user {
                id
                firstname
                lastname
              }
            }
          }
        }
        `

export const SAVE_JOURNAL_DRAFT = gql`
          mutation addJournal($user_id: Int, $title: String, $body: String, $participants: user_group_arr_rel_insert_input) {
            insert_user_content(
              objects: {
                status: DRAFT, content: {data: {title: $title, body: $body}},
                group: {
                  data: {
                    name: "",
                    type: THREAD_JOURNAL,
                    user_groups: $participants
                  }
                },
                user_id: $user_id,
                context_type: USER_CONTENT,
                type: JOURNAL
              }
            ) {
              affected_rows
              returning {
                id
                status
                created_at
                updated_at
                group_id
                content {
                  id
                  title
                  body
                  files: content_assets {
                    asset {
                      id
                      type
                      description
                      url
                    }
                  }
                }
              }
            }
          }
          `

export const SAVE_JOURNAL = gql`
          mutation saveJournal($content_id: Int, $user_content_id: Int, $title: String, $body: String, $updated_at: timestamptz) {
            update_content(where: {id: {_eq: $content_id}}, _set: {title: $title, body: $body}) {
              affected_rows
            }
            update_user_content(where: {id: {_eq: $user_content_id}}, _set: {status: DRAFT, updated_at: $updated_at}) {
              affected_rows
              returning {
                id
                status
                created_at
                updated_at
                group_id
                content {
                  id
                  title
                  body
                  files: content_assets {
                    asset {
                      id
                      type
                      description
                      url
                    }
                  }
                }
              }
            }
          }
         `

export const SUBMIT_JOURNAL = gql`
         mutation saveJournal($content_id: Int, $user_content_id: Int, $title: String, $body: String, $updated_at: timestamptz) {
            update_content(where: {id: {_eq: $content_id}}, _set: {title: $title, body: $body}) {
              affected_rows
            }
            update_user_content(where: {id: {_eq: $user_content_id}}, _set: {status: SUBMITTED, updated_at: $updated_at}) {
              affected_rows
              returning {
                id
                status
                created_at
                updated_at
                group_id
                content {
                  id
                  title
                  body
                  files: content_assets {
                    asset {
                      id
                      type
                      description
                      url
                    }
                  }
                }
              }
            }
          }
        `

export const DELETE_JOURNAL = gql`
          mutation deleteJournal($id: Int) {
            update_user_content(where: {id: {_eq: $id}}, _set: {status: DELETED}) {
              affected_rows
            }
          }
          `

export const EDIT_JOURNAL = gql`
        mutation deleteJournal($id: Int) {
          update_user_content(where: {id: {_eq: $id}}, _set: {status: DRAFT}) {
            affected_rows
            returning {
                id
                status
                created_at
                updated_at
                group_id
                content {
                  id
                  title
                  body
                  files: content_assets {
                    asset {
                      id
                      type
                      description
                      url
                    }
                  }
                }
              }
            }
          }
        `

export const UPLOAD_CONTENT_ASSET = gql`
        mutation uploadContentAsset($contentId: Int!, $assetId: Int!) {
          insert_content_asset(objects: {asset_id: $assetId, content_id: $contentId}) {
            affected_rows
          }
        }
        `

export const UPLOAD_ASSET = gql`
        mutation uploadAsset($newAttachment: [asset_insert_input!]!) {
          insert_asset(objects: $newAttachment) {
            affected_rows
            returning {
              id
              content_assets {
                content_id
              }
            }
          }
        }
        `

export const REMOVE_ASSET = gql`
        mutation removeAttachment($asset_id: Int, $content_id: Int) {
          delete_content_asset(where: {asset_id: {_eq: $asset_id}, content_id: {_eq: $content_id}}) {
            affected_rows
          }
        }
        `

export const ACKNOWLEDGE_JOURNAL = gql`
          mutation MyMutation($id: Int) {
            update_user_content(where: {id: {_eq: $id}}, _set: {status: ACKNOWLEDGED}) {
              affected_rows
              returning {
                  id
                  status
                  created_at
                  updated_at
                  group_id
                  content {
                    id
                    title
                    body
                    files: content_assets {
                      asset {
                        id
                        type
                        description
                        url
                      }
                    }
                  }
                  group {
                  user_groups(where: {role: {id: {_eq: 2}}}) {
                    user_id
                    user {
                      firstname
                      lastname
                    }
                  }
                }
                }
              }
            }
          `

export const SUBSCRIPTION_UNREAD_JOURNAL_COUNT = gql`
  subscription unreadCount($userId: Int) {
    user_content_aggregate(where: {type: {_eq: JOURNAL}, status: {_eq: SUBMITTED}, group: {user_groups: {user: {id: {_eq: $userId}}}}}) {
      aggregate {
        count
      }
    }
  }
  `

export const journalDraft = {
  status: 'DRAFT',
  created_at: moment(),
  content: {
    title: 'My Daily Journal',
    body: '',
    files: []
  }
}
